import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { UtilsService } from '../../services/utils.service';
import {
  slideInOutAnimation,
  overlayFadeInOutAnimation,
} from '../reusable-animations/card-estimate-drawer-animations';
import { MobileBreakPointsService } from 'src/app/services/mobileBreakPoints.service';
@Component({
    selector: 'app-card-customer-support',
    templateUrl: './card-customer-support.component.html',
    styleUrls: ['./card-customer-support.component.scss'],
    animations: [slideInOutAnimation, overlayFadeInOutAnimation],
    standalone: false
})
export class CardCustomerSupportComponent {
  private _labels: any;
  isSupportPanelOpen: boolean = false;
  isMobile$: Observable<boolean>;
  private _displayMobile: boolean = true;
  public get displayMobile() {
    return this._displayMobile;
  }

  @Input() public set labels(labels: any) {
    this._labels = labels;
  }

  public get labels() {
    return this._labels;
  }
  @ViewChild('menuOrDrawer', { static: false, read: ElementRef })
  menuOrDrawer!: ElementRef;
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (
      this.menuOrDrawer &&
      !this.menuOrDrawer.nativeElement.contains(event.target)
    ) {
      this.isSupportPanelOpen = false;
    }
  }
  constructor(
    private utilsService: UtilsService,
    private _mobileBreakPoinntService: MobileBreakPointsService
  ) {
    this.isMobile$ = this._mobileBreakPoinntService.mobileBreakPoints$;
  }

  toggleSupportPanel() {
    this.isSupportPanelOpen = !this.isSupportPanelOpen;
  }

  onClose() {
    this.isSupportPanelOpen = false;
  }
}
